<template>
<body>
  <!-- <input ref="autocomplete" v-model="address1" type="text" class="form-field modal-field-input" maxlength="100" name="email-2" data-name="name" placeholder="1212 42nd St" id="email-2" required="" /> -->
  <div class="modalContainer active loginModal formsModal">
    <div class="actualModal">

      <!-- <a href="#" class="closeModal"><i class="fal fa-times"></i></a> -->
      <form @submit.prevent="handleSubmit" class="modalBodyOfItem">
        <div class="itemBodyLeftModal">
          <h4>Account Setup/Address</h4>
          <div class="inputsContainer">
            <div class="individualInput">
              <h5>Address</h5>
              <input ref="autocomplete" v-model="address1" type="text" name="address1" id="address" placeholder="123 Cherry Ave" />
            </div>
            <div class="dualInputContainer">
              <div class="individualInput">
                <h5>City</h5>
                <input v-model="city" type="text" placeholder="New York" />
                <!--<select>
                    <option value="volvo">Select One</option>
                    <option value="saab">Select One</option>
                    <option value="mercedes">Select One</option>
                    <option value="audi">Select One</option>
                  </select> -->
              </div>

            <div class="individualInput">
              <h5>Zip Code</h5>
              <input maxlength="10" v-model="zip" type="text" name="" id="" placeholder="10001" />
            </div>
            </div>
            <div class="dualInputContainer">

              <div v-if="country == 'US'" class="individualInput">
                <h5>State</h5>
                <select v-model="state">
                  <option v-for="(state,key) in states" :value="key">{{state}}</option>
                  <!-- <option value="volvo">Select One</option>
                    <option value="saab">Select One</option>
                    <option value="mercedes">Select One</option>
                    <option value="audi">Select One</option> -->
                </select>
              </div>

              <div v-if="country != 'US'" class="individualInput">
                <h5>State</h5>
                <input v-model="this.state" placeholder="State">
              </div>
              <!-- country select -->

              <div class="individualInput">
                <h5>Country</h5>
                <select v-model="country">
                  <option v-for="(country,key) in countries" :value="key">{{country}}</option>
                  <!-- <option value="volvo">Select One</option>
                    <option value="saab">Select One</option>
                    <option value="mercedes">Select One</option>
                    <option value="audi">Select One</option> -->
                </select>
              </div>
          </div>
          </div>
          <div class="quickCheckout">
            <div style="margin-bottom: 5px;" v-if="haserrors" class="error">Please enter a valid
              address.</div>
            <button type="submit">Continue</button>
          </div>
          <div class="formProgress">
            <p>2/3</p>
          </div>
        </div>
      </form>
    </div>
  </div>
</body>
</template>
<script>
import validator from 'validator'
import states from '@/helpers/states'
import countries from '@/helpers/countries'

const ADDRESS_COMPONENTS = {
  subpremise: 'short_name',
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'short_name',
  administrative_area_level_2: 'long_name',
  country: 'long_name',
  postal_code: 'short_name'
};
const CITIES_TYPE = ['locality', 'administrative_area_level_3'];
const REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country',
  'administrative_area_level_1', 'administrative_area_level_2'
];
export default {
  name: 'SignUp',
  data() {
    return {
      haserrors: false,
      states,
      address1: null,
      city: null,
      zip: null,
      state: null,
      country: 'US',
      countryString: 'United States',
      countries,
    }
  },
  created() {
    this.$store.dispatch('auth/fetchUser')
  },
  mounted() {
    this.autocomplete = new google.maps.places.Autocomplete(
      (this.$refs.autocomplete), {
        types: ['geocode'],
      }
    );
    this.autocomplete.addListener('place_changed', (x) => {
      let place = this.autocomplete.getPlace();
      console.log(place)
      let ac = place.address_components;
      let lat = place.geometry.location.lat();
      let lon = place.geometry.location.lng();
      let formatted = this.formatResult(place)
      console.log(`address:`, formatted)
      // console.log(ac[0], 67, ac, place)
      // let city = ac[0]["short_name"];
      this.city = formatted.locality
      this.address1 = formatted.street_number + ' ' + formatted.route
      this.state = formatted.administrative_area_level_1
      this.zip = formatted.postal_code
      this.countryString  = formatted.country
      console.log(`The user picked coordinates ${lat}, ${lon} country ${formatted.country}`);
    });
  },
  methods: {
    getCountryCodeFromString(str) {
      for (let k in this.countries) {
        if(this.countries[k] == str) {
          return k
        }
      }
    },
    formatResult(place) {
      let returnData = {};
      for (let i = 0; i < place.address_components.length; i++) {
        let addressType = place.address_components[i].types[0];
        if (ADDRESS_COMPONENTS[addressType]) {
          let val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
          returnData[addressType] = val;
        }
      }
      returnData['latitude'] = place.geometry.location.lat();
      returnData['longitude'] = place.geometry.location.lng();
      return returnData
    },
    handleSubmit(e) {
      console.log('form submitted')
      let {
        address1,
        city,
        zip,
        state,
        country
      } = this
      if (address1 && city && zip && state) {
        let billingAddress = {
          address1,
          city,
          zip,
          state,
          country
        }
        let payload = {
          billingAddress
        }
        console.log(`dispatching address to setup with payload`, payload)
        this.$store.dispatch('setup/step2', payload)
      } else {
        this.haserrors = true
      }
    }
  },
  watch: {
    countryString(n,o) {
      let code = this.getCountryCodeFromString(n)
      console.log(n,code)
      this.country = code
    },
    '$route'(to, from) {
      // react to route changes...
      this.token = this.$route.query.token
    }
  }

}
</script>
<style>
.sign-up-page-wrapper {
  padding: 5px;
}
</style>
